import { render } from "./notAuthorized.vue?vue&type=template&id=bf84a8d8"
import script from "./notAuthorized.vue?vue&type=script&lang=js"
export * from "./notAuthorized.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__